export default __webpack_public_path__ + "static/media/baby-26.4d96f2a8.svg";